import "./styles.css";

export const AUTOFILL_NOTICE_DEFAULT =
  "We filled some answers in for you. Check them and change anything that is wrong.";

export interface AutofillNoticeProps {
  notice?: string;
  fieldLabels: readonly string[];
}

export function AutofillNotice({ notice, fieldLabels }: AutofillNoticeProps) {
  const copy = notice?.trim() ? notice.trim() : AUTOFILL_NOTICE_DEFAULT;
  const labels = fieldLabels.filter((label) => label.trim().length > 0);
  if (labels.length === 0) return null;
  return (
    <div className="callout autofill-notice" role="status">
      <span className="callout-mark" aria-hidden="true">i</span>
      <div>
        <p className="autofill-notice-copy">{copy}</p>
        <ul className="autofill-notice-fields">
          {labels.map((label, index) => (
            <li className="autofill-notice-field" key={`${index}:${label}`}>{label}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
